import Icon from '../components/Icon.vue'

Icon.register({"google-plus":{"width":2304,"height":1792,"paths":[{"d":"M1437 913q0 208-87 370.5t-248 254-369 91.5q-149 0-285-58t-234-156-156-234-58-285 58-285 156-234 234-156 285-58q286 0 491 192l-199 191q-117-113-292-113-123 0-227.5 62t-165.5 168.5-61 232.5 61 232.5 165.5 168.5 227.5 62q83 0 152.5-23t114.5-57.5 78.5-78.5 49-83 21.5-74h-416v-252h692q12 63 12 122zM2304 791v210h-209v209h-210v-209h-209v-210h209v-209h210v209h209z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/google-plus.js
// module id = 349
// module chunks = 0